<app-landing-header></app-landing-header>
<div #contentWrapper class="wrapper">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>

<app-landing-footer></app-landing-footer>